import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, ContentChild, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["*"];
function CardComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function CardComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
const _c1 = [[["sol-card-body"]], [["sol-card-footer"]]];
const _c2 = ["sol-card-body", "sol-card-footer"];
class CardBodyComponent {
  constructor() {}
  ngOnInit() {}
  static {
    this.ɵfac = function CardBodyComponent_Factory(t) {
      return new (t || CardBodyComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardBodyComponent,
      selectors: [["sol-card-body"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardBodyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardBodyComponent, [{
    type: Component,
    args: [{
      selector: 'sol-card-body',
      template: '<ng-content></ng-content>',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush
    }]
  }], () => [], null);
})();
class CardFooterComponent {
  constructor() {}
  ngOnInit() {}
  static {
    this.ɵfac = function CardFooterComponent_Factory(t) {
      return new (t || CardFooterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardFooterComponent,
      selectors: [["sol-card-footer"]],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function CardFooterComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardFooterComponent, [{
    type: Component,
    args: [{
      selector: 'sol-card-footer',
      template: '<ng-content></ng-content>',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush
    }]
  }], () => [], null);
})();
class CardComponent {
  constructor() {
    this.useAlternativeBackgroundColor = false;
    this.divider = true;
    this.enableHover = false;
    this.hasBody = false;
    this.hasFooter = false;
  }
  ngAfterContentInit() {
    this.hasBody = !!this.body;
    this.hasFooter = !!this.footer;
  }
  static {
    this.ɵfac = function CardComponent_Factory(t) {
      return new (t || CardComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardComponent,
      selectors: [["sol-card"]],
      contentQueries: function CardComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, CardBodyComponent, 5);
          i0.ɵɵcontentQuery(dirIndex, CardFooterComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.body = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footer = _t.first);
        }
      },
      inputs: {
        useAlternativeBackgroundColor: "useAlternativeBackgroundColor",
        divider: "divider",
        enableHover: "enableHover"
      },
      ngContentSelectors: _c2,
      decls: 3,
      vars: 8,
      consts: [[1, "sol-card"], ["class", "sol-card-body body", 4, "ngIf"], ["class", "sol-card-footer", 4, "ngIf"], [1, "sol-card-body", "body"], [1, "sol-card-footer"]],
      template: function CardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c1);
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, CardComponent_div_1_Template, 2, 0, "div", 1)(2, CardComponent_div_2_Template, 2, 0, "div", 2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("show-divider", ctx.hasBody && ctx.hasFooter && ctx.divider)("use-alternate-background-color", ctx.useAlternativeBackgroundColor)("hoverable", ctx.enableHover);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.hasBody);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.hasFooter);
        }
      },
      dependencies: [i1.NgIf],
      styles: [".sol-card{padding:1rem;border-radius:var(--radii-large-allcorners);border:1px solid var(--color-interface-border1);background-color:#fff;gap:var(--gap12)}.sol-card.use-alternate-background-color{background-color:var(--color-interface-background50)}.sol-card.hoverable:hover{background-color:var(--color-interface-background100)}.sol-card .sol-card-body{font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height)}.sol-card .sol-card-footer{font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);margin-top:.25rem;padding-top:.75rem}.sol-card.show-divider .sol-card-footer{margin-top:.75rem;border-top:1px solid var(--color-interface-border1)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardComponent, [{
    type: Component,
    args: [{
      selector: 'sol-card',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div\n  [class.show-divider]=\"hasBody && hasFooter && divider\"\n  [class.use-alternate-background-color]=\"useAlternativeBackgroundColor\"\n  [class.hoverable]=\"enableHover\"\n  class=\"sol-card\"\n>\n  <div *ngIf=\"hasBody\" class=\"sol-card-body body\">\n    <ng-content select=\"sol-card-body\"></ng-content>\n  </div>\n  <div *ngIf=\"hasFooter\" class=\"sol-card-footer\">\n    <ng-content select=\"sol-card-footer\"></ng-content>\n  </div>\n</div>\n",
      styles: [".sol-card{padding:1rem;border-radius:var(--radii-large-allcorners);border:1px solid var(--color-interface-border1);background-color:#fff;gap:var(--gap12)}.sol-card.use-alternate-background-color{background-color:var(--color-interface-background50)}.sol-card.hoverable:hover{background-color:var(--color-interface-background100)}.sol-card .sol-card-body{font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height)}.sol-card .sol-card-footer{font-family:var(--typography-opensans-body-body3-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body3-font-weight);line-height:var(--typography-opensans-body-body3-line-height);margin-top:.25rem;padding-top:.75rem}.sol-card.show-divider .sol-card-footer{margin-top:.75rem;border-top:1px solid var(--color-interface-border1)}\n"]
    }]
  }], () => [], {
    body: [{
      type: ContentChild,
      args: [CardBodyComponent]
    }],
    footer: [{
      type: ContentChild,
      args: [CardFooterComponent]
    }],
    useAlternativeBackgroundColor: [{
      type: Input
    }],
    divider: [{
      type: Input
    }],
    enableHover: [{
      type: Input
    }]
  });
})();
class CardModule {
  static {
    this.ɵfac = function CardModule_Factory(t) {
      return new (t || CardModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CardModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardModule, [{
    type: NgModule,
    args: [{
      declarations: [CardComponent, CardBodyComponent, CardFooterComponent],
      exports: [CardComponent, CardBodyComponent, CardFooterComponent],
      imports: [CommonModule]
    }]
  }], null, null);
})();

/*
 * Public API Surface of Card
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardBodyComponent, CardComponent, CardFooterComponent, CardModule };
